import { z } from "zod";

/**
 * Desliga a compilação sob demanda do Zod **no navegador**, e só nele.
 *
 * O Zod 4 tenta compilar validadores rápidos com `new Function`. Antes de
 * usá-la ele sonda a capacidade, dentro de um `try/catch`:
 *
 *     try { const F = Function; new F(""); return true } catch { return false }
 *
 * Sob a CSP do Noesis — `script-src 'self'`, sem `unsafe-eval` — a sonda
 * sempre lança, o Zod cai no caminho interpretado e **nada quebra**. Mas o
 * navegador não sabe que a exceção era esperada: ele registra uma violação de
 * `script-src` e imprime um erro no console a cada carregamento. Era a única
 * sujeira no console de produção, e ela não vinha do Noesis.
 *
 * `jitless: true` faz o Zod pular a sonda. Como sob esta política o JIT já era
 * impossível, isto **não muda desempenho nenhum**: só deixa de perguntar o que
 * já se sabe. O próprio Zod documenta o caso no `util.cjs` — "skip the probe
 * under `jitless`: strict CSPs report the caught `new Function`".
 *
 * Fica em `apps/web`, e não em `packages/shared`, de propósito: na API não há
 * CSP, o `new Function` funciona, e lá o JIT é ganho de verdade na validação
 * de toda requisição. Este arquivo é o primeiro `import` do `main.tsx` para
 * rodar antes do primeiro `parse`.
 */
z.config({ jitless: true });
